import { render, staticRenderFns } from "./planDetails_fl.vue?vue&type=template&id=ea5fa1c0&scoped=true"
import script from "./planDetails_fl.vue?vue&type=script&lang=js"
export * from "./planDetails_fl.vue?vue&type=script&lang=js"
import style0 from "./planDetails_fl.vue?vue&type=style&index=0&id=ea5fa1c0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea5fa1c0",
  null
  
)

export default component.exports